import { AppBBWaardecheckAppraisalRequestPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../../../constants';

export default (): AppBBWaardecheckAppraisalRequestPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_BBWAARDECHECK_APPRAISALREQUEST_POINTER,
  variable: null,
});
